const assignBox = {
  form: {
    generalForm: {
      header: 'Configuración avanzada de asignación de conductores',
      actions: {
        saveCheckBox: 'Guardar como predeterminado',
      },
      formBtns: {
        btnCancel: 'Cancelar',
        btnAssign: 'Asignar',
      },
      inputAssignBy: 'Tipo de asignación',
      inputActualDrivers: 'Real',
      inputVirtualDrivers: 'Virtual',
    },
    actualForm: {
      information: {
        inputOnlyDrivers: 'Ignorar turnos del conductor',
        inputMaxShiftsHours: 'Máx. Horas de turnos',
        defaultCarLocation: 'Ubicación predeterminada del coche',
        inputMaxPrice: 'Precio máximo',
        inputFillVirtual: 'Llenar sin asignar con conductores virtuales',
        inputMaxTrips: 'Viajes máximos',
        inputAssignFairly: 'Asignar razonablemente',
      },
      validations: {
        maxShifts: {
          require: 'Obligatorio',
          min: 'Al menos 1',
          max: 'Máximo 24',
        },
        carLocation: {
          require: 'Obligatorio',
        },
        fillVirtual: {
          require: 'Obligatorio',
        },
        maxTrips: {
          require: 'Obligatorio',
        },
        maxPrice: {
          require: 'Obligatorio',
        },
        default: {
          require: 'Obligatorio',
        },
      },
    },
    virtualForm: {
      information: {
        inputUpTo: 'Hasta',
        inputDrivers: 'Conductores',
        inputMaxSeats: 'Asientos Máx.',
        inputMaxShiftsHours: 'Máx. Horas de turnos',
        defaultCarLocation: 'Ubicación predeterminada del coche',
        inputAssignFairly: 'Asignar razonablemente',
      },
      validations: {
        limitDrivers: {
          require: 'Obligatorio',
        },
        carLocation: {
          require: 'Obligatorio',
        },
        maxShifts: {
          require: 'Obligatorio',
          min: 'Al menos 1',
          max: 'Máximo 24',
        },
        default: {
          require: 'Obligatorio',
        },
      },
    },
    errorsMessages: {
      updateCar: 'No se pudo actualizar la ubicación del coche',
    }
  },
};

export default assignBox;
